import http from '../http'
import { Res } from '../type'
import { LiveDetailParams, LiveRoomList, LiveRoomListParams, RedirectUrlParams, RedirectUrlRecord } from '../Models/LiveRoomList'

export const getLivestreamList = (params: LiveRoomListParams): Res<LiveRoomList> => {
  return http.request({
    url: '/sands-lms/api/v1/livestream/page',
    method: 'POST',
    data: params,
    loadingShow: '0'
  })
}

export const getLivestreamRedirect = (params: RedirectUrlParams): Res<RedirectUrlRecord> => {
  return http.request({
    url: '/sands-lms/api/v1/livestream/redirect',
    method: 'get',
    loadingShow: '0',
    params
  })
}

// 直播详情
export const getLivestreamDetail = (params: LiveDetailParams): Res<LiveRoomList> => {
  return http.request({
    url: '/sands-lms/api/v1/livestream/get',
    method: 'get',
    loadingShow: '0',
    params
  })
}
